import { render, staticRenderFns } from "./SourceStorage.vue?vue&type=template&id=20e895d5&"
import script from "./SourceStorage.vue?vue&type=script&lang=js&"
export * from "./SourceStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports